import React, { useEffect, useState } from 'react'
import { todos } from '../../../assets/data/todos'
import Titles from './Titles'
import Details from './Details'
import styles from './Main.module.css'

const Main = () => {

    const [selectedType, setSelectedType] = useState('pending')
    const [selectedItem, setSelectedItem] = useState<any>([])
    const [data, setData] = useState<any>()

    useEffect(() => {
        setData(todos)
        setSelectedItem(todos[0])
    }, [])

    const getSelectedItem = (id: string) => {
        const selectedItem = todos.find(item => item.id === id)
        setSelectedItem(selectedItem)
    }

    return (
        <div className={`row ${styles.todosContainer} bg-white`}>
            {
                data && data.length > 0 ?
                    <>
                        <div className="col-3">
                            <Titles 
                                todos={todos} 
                                selectedType={selectedType} 
                                setSelectedType={setSelectedType} 
                                getSelectedItem={getSelectedItem} 
                                selectedId={selectedItem.id}
                            /> 
                        </div>
                        <div className="col-9">
                            <Details 
                                selectedType={selectedType}
                                selectedItem={selectedItem} 
                            />
                        </div>
                    </> :
                    null

            }
        </div>
    )
}

export default Main
